import React from 'react'

import { ReactComponent as EmptyLineChart } from './emptyLineChart.svg'
import { ReactComponent as EmptyResourcesList } from './emptyResourcesList.svg'
import { ReactComponent as EmptyBarChart } from './emptyBarChart.svg'
import { ReactComponent as EmptyPillars } from './emptyPillars.svg'
import { ReactComponent as EmptyPillarDetail } from './emptyPillarDetail.svg'
import { ReactComponent as EmptyGeneralGoals } from './emptyGeneralGoals.svg'

const ContentIconMapper = {
    lineChart: EmptyLineChart,
    resourcesList: EmptyResourcesList,
    barChart: EmptyBarChart,
    pillars: EmptyPillars,
    pillarDetail: EmptyPillarDetail,
    worldCloud: EmptyGeneralGoals,
}

function EmptyComponent({ title, message = 'Not enough data yet!', contentType, style = {} }) {
    let ContentView = ContentIconMapper[contentType]
    return (
        <div className="module" style={{ position: 'relative', ...style }}>
            {title && (
                <div className="module-header">
                    <h2>{title}</h2>
                </div>
            )}
            {ContentView && <ContentView />}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <p>{message}</p>
            </div>
        </div>
    )
}

export default EmptyComponent
